<script>
import { deepClone } from "../../utils/index";
import render from "../render/render.js";

const ruleTrigger = {
  "el-input": "blur",
  "el-input-number": "blur",
  "el-select": "change",
  "el-radio-group": "change",
  "el-checkbox-group": "change",
  "el-cascader": "change",
  "el-time-picker": "change",
  "el-date-picker": "change",
  "el-rate": "change",
};

const layouts = {
  colFormItem(h, scheme) {
    const config = scheme.__config__;
    const listeners = buildListeners.call(this, scheme);

    let labelWidth = config.labelWidth ? `${config.labelWidth}px` : null;
    if (config.showLabel === false) labelWidth = "0";

    return h("el-col", { props: { span: config.span } }, [
      h(
        "el-form-item",
        {
          props: {
            "label-width": labelWidth,
            prop: scheme.__vModel__,
            label: config.showLabel ? config.label : "",
          },
        },
        [
          h("render", {
            props: { conf: scheme },
            ...{ on: listeners },
          }),
        ]
      ),
    ]);

    // return (
    //   <el-col span={config.span}>
    //     <el-form-item
    //       label-width={labelWidth}
    //       prop={scheme.__vModel__}
    //       label={config.showLabel ? config.label : ""}
    //     >
    //       <render conf={scheme} {...{ on: listeners }} />
    //     </el-form-item>
    //   </el-col>
    // );
  },
  rowFormItem(h, scheme) {
    let child = renderChildren.apply(this, arguments);
    if (scheme.type === "flex") {
      child = h(
        "el-row",
        {
          props: {
            type: scheme.type,
            justify: scheme.justify,
            align: scheme.align,
          },
        },
        child
      );
      // child = (
      //   <el-row
      //     type={scheme.type}
      //     justify={scheme.justify}
      //     align={scheme.align}
      //   >
      //     {child}
      //   </el-row>
      // );
    }

    return h("el-col", { props: { span: scheme.span } }, [
      h("el-row", { props: { gutter: scheme.gutter } }, child),
    ]);

    // return (
    //   <el-col span={scheme.span}>
    //     <el-row gutter={scheme.gutter}>{child}</el-row>
    //   </el-col>
    // );
  },
};

function renderSlot(h, _default) {
  return h("el-col", { props: { span: 24 } }, [_default]);
}

function renderFrom(h) {
  const { formConfCopy } = this;
  let formChild = [];
  let formBtnDoms = [];

  const formItem = renderFormItem.call(this, h, formConfCopy.fields);
  if (formConfCopy.formBtns) {
    formBtnDoms = formBtns.call(this, h);
  }

  formChild = formChild.concat(formItem);
  formChild = formChild.concat(formBtnDoms);
  formChild.push(renderSlot(h, this.$slots.default));

  // h("div", [this.$slots.default])

  const elFormDom = h(
    "el-form",
    {
      props: {
        size: formConfCopy.size,
        labelPosition: formConfCopy.labelPosition,
        disabled: formConfCopy.disabled,
        labelWidth: `${formConfCopy.labelWidth}px`,
        model: this[formConfCopy.formModel],
        rules: this[formConfCopy.formRules],
      },
      ref: formConfCopy.formRef,
    },
    formChild
  );

  const doms = h("el-row", { props: { gutter: formConfCopy.gutter } }, [
    elFormDom,
  ]);
  return doms;

  // return (
  //   <el-row gutter={formConfCopy.gutter}>
  //     <el-form
  //       size={formConfCopy.size}
  //       label-position={formConfCopy.labelPosition}
  //       disabled={formConfCopy.disabled}
  //       label-width={`${formConfCopy.labelWidth}px`}
  //       ref={formConfCopy.formRef}
  //       // model不能直接赋值 https://github.com/vuejs/jsx/issues/49#issuecomment-472013664
  //       props={{ model: this[formConfCopy.formModel] }}
  //       rules={this[formConfCopy.formRules]}
  //     >
  //       {renderFormItem.call(this, h, formConfCopy.fields)}
  //       {formConfCopy.formBtns && formBtns.call(this, h)}
  //     </el-form>
  //   </el-row>
  // );
}

function formBtns(h) {
  return h("el-col", {}, [
    h("el-form-item", { props: { size: "large" } }, [
      h(
        "el-button",
        { props: { type: "primary" }, on: { click: this.submitForm } },
        "提交"
      ),
      h("el-button", { on: { click: this.resetForm } }, "重置"),
    ]),
  ]);
  // return (
  //   <el-col>
  //     <el-form-item size="large">
  //       <el-button type="primary" onClick={this.submitForm}>
  //         提交
  //       </el-button>
  //       <el-button onClick={this.resetForm}>重置</el-button>
  //     </el-form-item>
  //   </el-col>
  // );
}

function renderFormItem(h, elementList) {
  return elementList.map((scheme) => {
    const config = scheme.__config__;
    const layout = layouts[config.layout];

    if (layout) {
      return layout.call(this, h, scheme);
    }
    throw new Error(`没有与${config.layout}匹配的layout`);
  });
}

function renderChildren(h, scheme) {
  const config = scheme.__config__;
  if (!Array.isArray(config.children)) return null;
  return renderFormItem.call(this, h, config.children);
}

function setValue(event, config, scheme) {
  this.$set(config, "defaultValue", event);
  this.$set(this[this.formConf.formModel], scheme.__vModel__, event);
  this.$emit("change", scheme, event, this[this.formConf.formModel]);
}

function buildListeners(scheme) {
  const config = scheme.__config__;
  const methods = this.formConf.__methods__ || {};
  const listeners = {};

  // 给__methods__中的方法绑定this和event
  Object.keys(methods).forEach((key) => {
    listeners[key] = (event) => methods[key].call(this, event);
  });
  // 响应 render.js 中的 vModel $emit('input', val)
  listeners.input = (event) => setValue.call(this, event, config, scheme);

  return listeners;
}

export default {
  components: {
    render,
  },
  props: {
    formConf: {
      type: Object,
      required: true,
    },
  },
  data() {
    const data = {
      formConfCopy: deepClone(this.formConf),
      [this.formConf.formModel]: {},
      [this.formConf.formRules]: {},
    };

    this.initDatasource(data.formConfCopy.fields);
    this.initFormData(data.formConfCopy.fields, data[this.formConf.formModel]);
    this.buildRules(data.formConfCopy.fields, data[this.formConf.formRules]);
    return data;
  },
  watch: {
    formConf: {
      handler(val) {
        this.initData();
      },
      deep: true,
    },
  },
  mounted() {},
  methods: {
    /**
     * 改变Conf值
     */
    changeConfValue(vModel, key, value) {
      const fields = this.formConfCopy.fields.filter(
        (item) => item.__vModel__ == vModel
      );
      if (fields.length <= 0) {
        return;
      }

      const keys = key.split(".");
      let data = fields[0];
      for (let i = 0; i < keys.length - 1; i++) {
        data = data[keys[i]];
      }

      this.$set(data, keys[keys.length - 1], value);
    },
    initData() {
      this.formConfCopy = deepClone(this.formConf);
      this.initDatasource(this.formConfCopy.fields);
      this.initFormData(
        this.formConfCopy.fields,
        this[this.formConf.formModel]
      );
      this.buildRules(this.formConfCopy.fields, this[this.formConf.formRules]);
    },
    initDatasource(fields) {
      for (const field of fields) {
        const { dataType, dataPath } = field.__config__;
        if (dataType === "datasource" && dataPath) {
          this.$emit("datasource-data", {
            dataPath: dataPath,
            callback: (datas) => {
              field.options = datas;
            },
          });
        }
      }
    },
    initFormData(componentList, formData) {
      componentList.forEach((cur) => {
        const config = cur.__config__;
        if (cur.__vModel__) formData[cur.__vModel__] = config.defaultValue;
        if (config.children) this.initFormData(config.children, formData);
      });
    },
    buildRules(componentList, rules) {
      componentList.forEach((cur) => {
        const config = cur.__config__;
        if (Array.isArray(config.regList)) {
          if (config.required) {
            const required = {
              required: config.required,
              message: cur.placeholder,
            };
            if (Array.isArray(config.defaultValue)) {
              required.type = "array";
              required.message = `请至少选择一个${config.label}`;
            }
            required.message === undefined &&
              (required.message = `${config.label}不能为空`);
            config.regList.push(required);
          }
          rules[cur.__vModel__] = config.regList.map((item) => {
            item.pattern && (item.pattern = eval(item.pattern));
            item.trigger = ruleTrigger && ruleTrigger[config.tag];
            return item;
          });
        }
        if (config.children) this.buildRules(config.children, rules);
      });
    },
    setFormData(formData, componentList) {
      const formModel = this[this.formConf.formModel];
      if (!componentList) componentList = this.formConfCopy.fields;

      componentList.forEach((cur) => {
        const config = cur.__config__;
        const key = cur.__vModel__;
        if (key && formData.hasOwnProperty(key)) {
          this.$set(formModel, key, formData[key]);
          this.$set(config, "defaultValue", formData[key]);
        }
        if (config.children) this.setFormData(formData, config.children);
      });
    },
    resetForm() {
      this.formConfCopy = deepClone(this.formConf);
      this.$refs[this.formConf.formRef].resetFields();
    },
    submitForm() {
      this.$refs[this.formConf.formRef].validate((valid) => {
        if (!valid) return false;
        // 触发sumit事件
        this.$emit("submit", this[this.formConf.formModel]);
        return true;
      });
    },
  },
  render(h) {
    return renderFrom.call(this, h);
  },
};
</script>
